export const calculateTotalOdds = (bets: { priceNumerator: number; priceDenominator: number }[]) => {
	if (!bets.length) return 0;
	return bets.reduce((total, bet) => {
		const { priceNumerator, priceDenominator } = bet;
		total *= priceNumerator / priceDenominator + 1;
		return total;
	}, 1);
};
